import {
  BODY_INPUT_DECIMAL_PLACE,
  BODY_SMALLEST_UNIT_DECIMAL_PLACE,
} from "config"
import { IBodyDisplayUnits } from "features/profile/profileTypes"
import { formatDisplayNumber, roundByDecimalPlace } from "utils"
import { kgToGram, poundToGram } from "./weightConverter"

const FEET_TO_INCHES_RATE = 12
const FEET_TO_MM_RATE = 304.8
const INCHES_TO_MM_RATE = 25.4
const CM_TO_MM_RATE = 10

export const MAX_CM_BODY_HEIGHT = 220
export const MIN_CM_BODY_HEIGHT = 120
export const DEFAULT_CM_BODY_HEIGHT = 165
export const DEFAULT_FEET = 5
export const DEFAULT_INCHES = 5

export const cmToMm = (cm: number) => {
  return roundByDecimalPlace(
    cm * CM_TO_MM_RATE,
    BODY_SMALLEST_UNIT_DECIMAL_PLACE,
  )
}

export const mmToCm = (mm: number) => {
  return roundByDecimalPlace(mm / CM_TO_MM_RATE, BODY_INPUT_DECIMAL_PLACE)
}

export const mmToFeetInches = (mm: number) => {
  const inches = mm / INCHES_TO_MM_RATE
  const feet = Math.floor(inches / FEET_TO_INCHES_RATE)
  const remainingInches = Math.round(inches % FEET_TO_INCHES_RATE)

  if (remainingInches === FEET_TO_INCHES_RATE) {
    return { feet: feet + 1, inches: 0 }
  }

  return { feet, inches: remainingInches }
}

export const getGramWeight = (
  bodyDisplayUnits: IBodyDisplayUnits,
  weight?: number,
) => {
  if (!weight) {
    return 0
  }
  return bodyDisplayUnits === "IMPERIAL"
    ? poundToGram(weight)
    : kgToGram(weight)
}

export const feetInchesToMm = (feet: number, inches: number) => {
  const totalMM = feet * FEET_TO_MM_RATE + inches * INCHES_TO_MM_RATE
  return roundByDecimalPlace(totalMM, 0)
}

export const getDisplayHeightWithUnit = (
  bodyDisplayUnits: IBodyDisplayUnits,
  height?: number,
) => {
  if (!height) {
    return "..."
  }

  if (bodyDisplayUnits === "IMPERIAL") {
    return mmToFeetInches(height)
  }

  return `${formatDisplayNumber(mmToCm(height), BODY_INPUT_DECIMAL_PLACE)} cm`
}
